<template>
    <div>
        <div class="bg-white rounded-md shadow overflow-hidden max-w-full">
            <form @submit.prevent="update">
                <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
                  <text-input type="hidden" v-model="form.parent_type_id" :error="form.errors.parent_type_id" />  
                  <text-input v-model="form.name" :error="form.errors.name" class="pr-6 pb-8 w-full w-full" :label="__('Name')" />

                  <select-edit-input :value="equipament.type"
                  :editable="true"
                   :placeholder="__('Type equipament')" :onInput="doFilter" :items="TypeEquipament" v-model="form.type_id" :error="form.errors.type_id"
                                class="pr-6 pb-8 w-full lg:w-1/4" :label="__('Type equipament')">
                  </select-edit-input>
 

                  <text-input v-model="form.serie" :placeholder="__('# Serie')" :error="form.errors.serie" class="pr-6 pb-8 w-full lg:w-1/4" :label="__('# Serie')" />

                   

                  <select-edit-input :value="equipament.location"
                  :editable="true"
                   :placeholder="__('Locations')" :onInput="doFilterLocation" :items="LocationList" v-model="form.location_id" :error="form.errors.location_id"
                                class="pr-6 pb-8 w-full lg:w-1/4" :label="__('Locations')">
                  </select-edit-input>

                  <select-edit-input :value="equipament.status" 
                  :editable="true"
                   :placeholder="__('Status Equipament')" :onInput="doFilterStatusEquipament" :items="StatusEquipamentList" v-model="form.status_id" :error="form.errors.status_id"
                                class="pr-6 pb-8 w-full lg:w-1/4" :label="__('Status Equipament')">
                  </select-edit-input>
 

                  <text-input type="date" v-model="form.buys" :placeholder="__('# Serie')" :error="form.errors.buys" class="pr-6 pb-8 w-full lg:w-1/6" :label="__('Date Buys')" />
                  <text-input v-model="form.supplier" :placeholder="__('Supplier')" :error="form.errors.serie" class="pr-6 pb-8 w-full lg:w-1/3" :label="__('Supplier')" />

                 

                  <select-edit-input :value="equipament.responsible_name" 
                  :editable="true"
                   :placeholder="__('Responsible')" :onInput="doFilterResponsible" :items="ResponsibleList" v-model="form.responsible" :error="form.errors.responsible"
                                class="pr-6 pb-8 w-full lg:w-1/4" :label="__('Responsible')">
                  </select-edit-input>
                  
                  <select-input :onChange="loadCategories" v-model="form.department_id" :error="form.errors.department_id" class="pr-6 pb-8 w-full lg:w-1/3" :label="__('Department')">
                        <option :value="null" />
                        <option v-for="s in Departments" :key="s.id" :value="s.id">{{ s.name }}</option>
                  </select-input>
                  
                  <select-input  v-model="form.category_id" :error="form.errors.category_id" class="pr-6 pb-8 w-full lg:w-1/3" :label="__('Category')" :required="true">
                        <option :value="null" />
                        <option v-for="s in Categories" :key="s.id" :value="s.id">{{ s.name }}</option>
                    </select-input>

                  <TextareaInput v-model="form.notes" class="pr-6 pb-8 w-full" :label="__('Notes')"></TextareaInput>
                  
                </div>

                <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
                    <loading-button :loading="form.processing" class="btn-indigo" type="submit">{{ __('Save') }}
                        {{ __('Equipament') }}</loading-button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import SelectInputFilter from '@/Shared/SelectInputFilter'
import SelectEditInput from '@/Shared/SelectEditInput'
import TextareaInput from '@/Shared/TextareaInput'
import LoadingButton from '@/Shared/LoadingButton'


export default {
    metaInfo: { title: 'Edit Ticket' },
    components: {
        LoadingButton,
        SelectInput,
        SelectInputFilter,
        TextInput,
        TextareaInput,
        Link,
        Icon,
        SelectEditInput
    },
    layout: Layout,
    props: {
        title: String,
        TypeEquipament:Object,
        LocationList : Object,
        equipament: Object,
        StatusEquipamentList :  Object,
        ResponsibleList : Object,
        Departments : Object,
        Categories : Object
    },
    remember: 'form',
    data() {
        return {
            form: this.$inertia.form({
                name: this.equipament.name,
                type_id : this.equipament.type_id,
                serie : this.equipament.serie,
                location_id : this.equipament.location_id,
                buys : this.equipament.buys,
                status_id : this.equipament.status_id,
                supplier : this.equipament.supplier,
                responsible : this.equipament.responsible,
                notes : this.equipament.notes,
                parent_type_id : this.equipament.parent_type_id,
                department_id: this.equipament.department_id,
                category_id : this.equipament.category_id,
            }),
        }
    },
    created() {
         
    },
    methods: {
        setDefaultValue(arr, key, value){
            const find = arr.find(i=>i.name.match(new RegExp(value + ".*")))
            if(find){
                this.form[key] = find['id']
            }
        },
        doFilter(e){
            this.axios.get(this.route('filter.lists.typeequipament', {search: e.target.value})).then((res)=>{
                this.TypeEquipament.splice(0, this.TypeEquipament.length, ...res.data);
            })
        },
        doFilterLocation(e){
            this.axios.get(this.route('filter.lists.locationlist', {search: e.target.value})).then((res)=>{
                this.LocationList.splice(0, this.LocationList.length, ...res.data);
            })
        },
        doFilterStatusEquipament(e){
            this.axios.get(this.route('filter.lists.statusequipament', {search: e.target.value})).then((res)=>{
                this.StatusEquipamentList.splice(0, this.StatusEquipamentList.length, ...res.data);
            })
        },
        doFilterResponsible(e){
            this.axios.get(this.route('filter.lists.statusequipament', {search: e.target.value})).then((res)=>{
                this.StatusEquipamentList.splice(0, this.StatusEquipamentList.length, ...res.data);
            })
        },
        update() {
            this.form.put(this.route('equipament.update', this.equipament.id))
        },
        loadCategories(e){ 
            this.axios.get(this.route('equipament.ajax', {opc: 'categories', department_id: e.target.value})).then((res)=>{
                this.Categories.splice(0, this.Categories.length, ...res.data);
            })
        }  
    }, 
}
</script>